export const ActionButtons = ({ step, edit, onCancel, onSubmit, disabled }) => {
  // Disable buttons only if step === 2 and disabled === true
  const isDisabled = step === 2 && disabled;

  return (
    <div className="flex justify-end gap-2 mb-6">
      {edit && (
        <button
          onClick={onCancel}
          disabled={isDisabled}
          className={`bg-white font-altis border border-[#572575] text-[#572575] text-[16px] px-6 py-3 rounded-lg font-semibold hover:bg-white transition-colors ${
            isDisabled ? "opacity-50 cursor-not-allowed" : ""
          }`}
        >
          Cancel
        </button>
      )}

      <button
        onClick={onSubmit}
        disabled={isDisabled}
        className={`bg-[#572575] font-altis text-white text-[16px] px-6 py-3 rounded-lg font-semibold hover:bg-[#572575] transition-colors ${
          isDisabled ? "opacity-50 cursor-not-allowed" : ""
        }`}
      >
        {step === 1
          ? "Calculate Funds"
          : step === 2
          ? edit
            ? "Save Changes"
            : "Add Sponsor"
          : edit
          ? "Save Changes"
          : "Add Plan"}
      </button>
    </div>
  );
};
